<template>
  <sTooltip
    :border="false"
    :content="value"
    :disabled="!isNeedTooltip"
    :open-delay="300"
    placement="bottom"
    popper-class="all-text-tooltip"
    type="white"
    @focus="$emit('focus')">
    <component
      v-if="textIsUrl"
      :is="tag"
      data-qa="tooltip-url">
      <a
        data-qa="tooltip-text-link"
        :href="url"
        target="_blank"> {{ shortString }}
      </a>
    </component>
    <component
      v-else
      :is="tag"
      data-qa="tooltip-text">
      {{ shortString }}
    </component>
  </sTooltip>
</template>

<script>
/**
* Сворачивание текста по количеству символов
* @category components
* @vue-prop {String} value - Текст (в случае url его описание)
* @vue-prop {Number} [maxLength=256] - Максимальная отображаемая длина
* @vue-prop {String} [tag='span'] - Тип эллемента
* @vue-prop {Boolean} [showTooltip=true] - Отобразить компонент разворота текста
* @vue-prop {Boolean} [textIsUrl=false] - Отобразить текст как ссылку
* @vue-prop {String} url - Текст
* @vue-computed {Boolean} isNeedTooltip - Необходимо сворачивать
* @vue-computed {Boolean} maxLengthComputed - Максимальная длина отображаемого текста
* @vue-computed {Boolean} shortString - Текст для отображения
*/

export default {
  name: 'tooltipedSymbolCount',
  props: {
    value: {
      type: String,
      default: '',
    },
    maxLength: {
      type: Number,
      default: 256,
    },
    tag: {
      type: String,
      default: 'span',
    },
    showTooltip: {
      type: Boolean,
      default: true,
    },
    textIsUrl: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
    },
  },
  computed: {
    isNeedTooltip() {
      if (!this.showTooltip || !this.value) {
        return false
      }
      return this.value.length > this.maxLengthComputed
    },
    maxLengthComputed() {
      if (!this.value) {
        return 0
      }
      return this.maxLength || this.value.length
    },
    shortString() {
      if (!this.value) {
        return ''
      }
      const shortString = this.value.substring(0, this.maxLengthComputed)
      return `${shortString}${ this.isNeedTooltip  ? ' ...' : ''}`
    },
  },
}
</script>
